var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaryChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 41,
    viewBox: "0 0 55 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0846 20.4823H35.8193V15.4421H18.8758V20.4823H1.61052C0.72259 20.4823 0.00195312 21.2029 0.00195312 22.0909V39.3561C0.00195312 40.2441 0.72259 40.9647 1.61052 40.9647H53.0846C53.9725 40.9647 54.6932 40.2441 54.6932 39.3561V22.0909C54.6932 21.2029 53.9725 20.4823 53.0846 20.4823Z",
    fill: "#AC6E4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: 15.1405,
    width: 54.691,
    height: 6.48877,
    fill: "#8544B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6933 22.0909V39.3561C54.6933 40.2441 53.9726 40.9647 53.0847 40.9647H27.3477V15.4421H35.8194V20.4823H53.0847C53.9726 20.4823 54.6933 21.2029 54.6933 22.0909Z",
    fill: "#995B3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7559 17.9213V23.3948C32.7559 24.1261 33.4711 24.719 34.3533 24.719H54.6941V17.9213H32.7559Z",
    fill: "#FFB454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 17.9213V24.719H20.3427C21.2249 24.719 21.9402 24.1261 21.9402 23.3948V17.9213H0.00195312Z",
    fill: "#FFCA55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61133 28.9541C7.29707 28.9541 11.9061 33.6704 11.9061 39.3562H1.61133V28.9541Z",
    fill: "#AC6E4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4096 40.9648H1.61052C0.722161 40.9648 0.00195312 40.2446 0.00195312 39.3562V27.4527C7.81668 26.4137 14.43 33.0812 13.4096 40.9648ZM3.21908 37.7477H10.1511C9.49946 34.1928 6.72779 31.3818 3.21908 30.7139V37.7477Z",
    fill: "#FDB953"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.791 39.3562C42.791 33.6704 47.4001 28.9541 53.0858 28.9541V39.3562H42.791Z",
    fill: "#995B3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.085 40.9648H41.286C40.2655 33.0812 46.8788 26.4137 54.6936 27.4527V39.3562C54.6936 40.2446 53.9734 40.9648 53.085 40.9648ZM44.5445 37.7477H51.4765V30.7139C47.9677 31.3818 45.1962 34.1928 44.5445 37.7477Z",
    fill: "#FDB953"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.877 15.4421V25.4142C18.877 30.079 22.6013 33.9481 27.2651 33.9943C32.1592 33.9943 35.8205 30.0877 35.8205 25.5225V15.4421H18.877Z",
    fill: "#FFCA55"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8194 15.4421V25.5225C35.8194 30.1938 32.02 33.9932 27.3477 33.9943V15.4421H35.8194Z",
    fill: "#FDB953"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9554 22.0911V25.5227C28.9554 26.4106 28.2348 27.1313 27.3468 27.1313C26.4589 27.1313 25.7383 26.4106 25.7383 25.5227V22.0911C25.7383 21.2032 26.4589 20.4825 27.3468 20.4825C28.2348 20.4825 28.9554 21.2032 28.9554 22.0911Z",
    fill: "#8544B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9562 22.0911V25.5227C28.9562 26.4106 28.2356 27.1313 27.3477 27.1313V20.4825C28.2356 20.4825 28.9562 21.2032 28.9562 22.0911Z",
    fill: "#AD71DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4332 0H11.2619C5.0432 0 0.00195312 5.04124 0.00195312 11.26V15.4422C0.00195312 15.4422 4.17028 13.8337 27.3476 13.8337C50.5248 13.8337 54.6932 15.4422 54.6932 15.4422V11.26C54.6932 5.04124 49.6519 0 43.4332 0Z",
    fill: "#AC6E4F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6933 11.26V15.4422C54.6933 15.4422 50.5249 13.8337 27.3477 13.8337V0H43.4333C49.652 0 54.6933 5.04124 54.6933 11.26Z",
    fill: "#995B3D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2108 13.8334H20.4844C20.4844 10.0426 23.5567 6.97021 27.3476 6.97021C31.1384 6.97021 34.2108 10.0426 34.2108 13.8334Z",
    fill: "#AC6CDC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2109 13.8334H27.3477V6.97021C31.1385 6.97021 34.2109 10.0426 34.2109 13.8334Z",
    fill: "#8544B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.666 13.1522C34.9121 9.24763 31.4687 6.28894 27.3476 6.28894C23.2264 6.28894 19.783 9.24763 19.0291 13.1522H0.00195312V16.3693H54.6932V13.1522H35.666ZM22.3449 13.1522C23.0259 11.0385 25.0109 9.50607 27.3476 9.50607C29.6843 9.50607 31.6692 11.0385 32.3502 13.1522H22.3449Z",
    fill: "#FFCA55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6933 13.1522V16.3693H27.3477V13.1522H32.3503C31.6693 11.0385 29.6844 9.50607 27.3477 9.50607V6.28894C31.4688 6.28894 34.9122 9.24763 35.6661 13.1522H54.6933Z",
    fill: "#FDB953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryChest);
export default __webpack_public_path__ + "static/media/diaryChest.8b01fd13cef002bb8ada8732be37aa33.svg";
export { ForwardRef as ReactComponent };